<template>
  <!-- Logo at the top aligned to the left -->
  <div style="width: 100%; margin-bottom: 20px">
    <img :src="broadridge_header" alt="Broadridge Logo"
         style="max-width: 200px;">
  </div>
</template>
<script setup>
import broadridge_header from '@/assets/broadridge_header.svg';
</script>

<script>
export default {
  name: 'Logo',
};
</script>